/**
 * ComingSoon.tsx — the holding page shown INSTEAD of the whole app when
 * `VITE_COMING_SOON=true` (see `comingSoonEnabled()` in `../config`).
 *
 * Owner repo: @thegpservice/gpsclinics-portal.
 *
 * WHY this exists: during the prod launch bake we deploy the latest build to
 * production but must take NO real patient orders while the backend is verified.
 * `main.tsx` renders THIS alone (no <BrowserRouter>, no <AuthProvider>, no App),
 * so the router, auth session and every API call are bypassed entirely — the
 * front door is a calm holding page, nothing more. Remove the prod
 * `VITE_COMING_SOON` variable and redeploy to go live.
 *
 * On-brand: GPS design tokens (`tokens.css`), Fraunces display + DM Sans body.
 * R28-safe: copy is category-level only — no medicine name, price or
 * treatment-mechanism wording (the source-tree scan in journey/r28.spec.tsx
 * enforces this file). Includes the healthcare emergency signpost (R31 spirit)
 * since a real patient may land here.
 */
import './ComingSoon.css';

export function ComingSoon() {
  const year = new Date().getFullYear();
  return (
    <main className="cs-root" role="main">
      <section className="cs-inner" aria-labelledby="cs-title">
        <span className="cs-mark" aria-hidden="true">
          {/* A leaf mark (wellness) — decorative; the copy carries the meaning. */}
          <svg viewBox="0 0 24 24" width="36" height="36" focusable="false">
            <path
              fill="currentColor"
              d="M6.05 8.05c-2.73 2.73-2.73 7.15-.02 9.88 1.47-3.4 4.09-6.24 7.36-7.93-2.77 2.34-4.71 5.61-5.39 9.32 2.6 1.23 5.8.78 7.95-1.37C19.43 14.47 20 4 20 4S9.53 4.57 6.05 8.05z"
            />
          </svg>
        </span>

        <p className="cs-eyebrow">The GP Service</p>
        <h1 id="cs-title" className="cs-title">We&rsquo;re getting everything ready</h1>
        <p className="cs-lead">
          Our clinician&#8209;led weight management service is launching very soon.
          Thank you for your patience while we put the finishing touches in place.
        </p>

        <span className="cs-divider" aria-hidden="true" />
        <p className="cs-note">
          If you need urgent medical help, call <strong>999</strong> or{' '}
          <strong>NHS&nbsp;111</strong>.
        </p>
      </section>

      <footer className="cs-foot">&copy; {year} The GP Service &middot; Novamedica Limited</footer>
    </main>
  );
}
